// @flow
import * as React from 'react';

import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Display from 'components/Display';
import Divider from 'components/Divider.jsx';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Menu from 'components/Menu.jsx';
import MenuButton from 'components/MenuButton.jsx';
import MenuItem from 'components/MenuItem.jsx';
import TextWithGlyph from 'components/TextWithGlyph.jsx';
import Tooltip from 'components/Tooltip.jsx';

type Props = {
  onEdit: () => void,
  onDuplicate: () => void,
  onDelete: () => void,
  onChangeStatus: () => void,
  isActivatable: boolean,
  canEdit: boolean,
  messageIsActive: boolean,
};

export default class AdminAutoMessageDetailViewActions extends React.PureComponent<Props, *> {
  render() {
    const {
      messageIsActive,
      onDuplicate,
      onChangeStatus,
      onDelete,
      onEdit,
      isActivatable,
      canEdit,
    } = this.props;

    const wrapInDisabledTooltip = (component: React.Node) => {
      return (
        <LayerTrigger
          noPointer
          layer={
            <Tooltip>
              It looks like not all of the required fields have been filled out yet. Click ‘Edit’ to
              complete and activate the message.
            </Tooltip>
          }>
          <span>{component}</span>
        </LayerTrigger>
      );
    };

    function ChangeStatusMenuItem() {
      return (
        <MenuItem
          data-test="activate-action-item"
          disabled={!isActivatable}
          onClick={isActivatable ? onChangeStatus : () => undefined}>
          <TextWithGlyph glyph={messageIsActive ? 'pause' : 'play'}>
            {messageIsActive ? 'Pause' : 'Activate'}
          </TextWithGlyph>
        </MenuItem>
      );
    }

    function ChangeStatusButton() {
      return (
        <Button
          disabled={!isActivatable}
          data-test="activate-button"
          onClick={isActivatable ? onChangeStatus : () => undefined}>
          <TextWithGlyph glyph={messageIsActive ? 'pause' : 'play'}>
            {messageIsActive ? 'Pause' : 'Activate'}
          </TextWithGlyph>
        </Button>
      );
    }

    const menu = (
      <Menu>
        <Display show="1200">
          {isActivatable ? (
            <ChangeStatusMenuItem />
          ) : (
            wrapInDisabledTooltip(<ChangeStatusMenuItem />)
          )}
          {canEdit && (
            <MenuItem data-test="edit-action-item" onClick={onEdit}>
              <TextWithGlyph glyph="pencil-stroke">Edit</TextWithGlyph>
            </MenuItem>
          )}
        </Display>
        <MenuItem data-test="duplicate-action-item" onClick={onDuplicate}>
          <TextWithGlyph glyph="drag-and-drop">Duplicate</TextWithGlyph>
        </MenuItem>
        {canEdit && (
          <React.Fragment>
            <MenuItem>
              <Divider size="flush" />
            </MenuItem>
            <MenuItem data-test="delete-action-item" onClick={onDelete}>
              <TextWithGlyph glyph="trash">Delete</TextWithGlyph>
            </MenuItem>
          </React.Fragment>
        )}
      </Menu>
    );

    return (
      <Buttons>
        <Display hide="1200">
          {isActivatable ? <ChangeStatusButton /> : wrapInDisabledTooltip(<ChangeStatusButton />)}
        </Display>
        {canEdit && (
          <Display hide="1200">
            <Button data-test="edit-button" level="secondary" onClick={onEdit}>
              Edit
            </Button>
          </Display>
        )}
        <MenuButton
          data-test="actions-button"
          menu={menu}
          level="secondary"
          color="koala"
          alignment="right"
          aria-label="More actions">
          <Glyph name="ellipses" size="small" solo />
        </MenuButton>
      </Buttons>
    );
  }
}
